"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var react_2 = require("swiper/react");
var ra_fetch_1 = require("ra-fetch");
function now() {
    var date = new Date();
    var month = date.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
    return date.getFullYear() + "-" + month + "-" + day;
}
function initParams(channel) {
    var params = {
        date: now(),
        video: true,
        lock_today: true,
        sort: 'start asc',
    };
    if (channel.id) {
        params.channel_id = channel.id;
        params.teams = channel.teams;
    }
    return params;
}
function Calender(_a) {
    var _b;
    var _c = _a.channel, channel = _c === void 0 ? {} : _c;
    var _d = ra_fetch_1.useApi('media').index('events', initParams(channel)), events = _d[0], setEvents = _d[1], params = _d[2], setParams = _d[3];
    return react_1.default.createElement("div", { className: 'storybook-events-calender' },
        react_1.default.createElement(storybook_1.Layouts.Container, null,
            react_1.default.createElement("div", { className: "py-8 md:py-12 flex flex-col " + (events.data.length > 0 ? 'gap-7' : '') },
                react_1.default.createElement(storybook_1.Layouts.Swiper, { className: 'storybook-events-calender-swiper', slidesPerView: 'auto', spaceBetween: 10, breakpoints: {} }, (_b = events.meta.days) === null || _b === void 0 ? void 0 : _b.map(function (day, index) { return (react_1.default.createElement(react_2.SwiperSlide, { key: index },
                    react_1.default.createElement(storybook_1.Calender.Day, { day: day.label, date: day.day, events: day.events, active: day.active, onClick: function () { return setParams(__assign(__assign({}, params), { date: day.date })); } }))); })),
                react_1.default.createElement("div", { className: 'storybook-events-calender-cards-container' }, events.data.map(function (event, index) { return react_1.default.createElement(storybook_1.Events.Card, { key: index, event: event }); })))));
}
exports.default = Calender;
